<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item label="开始时间">
					<el-date-picker
						v-model="filters.entimes"
						value-format="yyyy-MM-dd"
						style="width:100%"
						 type="date"
						 placeholder="选择日期"
					   />
				</el-form-item>
				<el-form-item label="结束时间">
					<el-date-picker
						v-model="filters.entimee"
						value-format="yyyy-MM-dd"
						style="width:100%"
						 type="date"
						 placeholder="选择日期"
					   />
				</el-form-item>
				<el-form-item>
					<el-input v-model="filters.service_code" placeholder="代码" @keyup.enter.native="getLists"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="getLists">搜索</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		<!--列表-->
		<el-table :data="datalist" border stripe highlight-current-row v-loading="listLoading" style="width:90%;" height="600">
			<el-table-column prop="service_code" label="代码" min-width="100">
			</el-table-column>
			<el-table-column prop="cpname" label="渠道" min-width="100">
			</el-table-column>
			<el-table-column prop="requests" label="请求" min-width="100">
			</el-table-column>
			<el-table-column prop="submits" label="提交" min-width="100">
			</el-table-column>
			<el-table-column prop="tjl" label="提交率" min-width="100">
			</el-table-column>
			<el-table-column prop="oksubmit" label="tb" min-width="100">
			</el-table-column>
			<el-table-column prop="cgl" label="同步率" min-width="100">
			</el-table-column>
			<el-table-column prop="zhl" label="转化率" min-width="100">
			</el-table-column>
		</el-table>
		<!--工具条翻页-->
		<el-col :span="24" class="toolbar">
		<el-pagination layout="total,prev, pager, next" @current-change="handleCurrentChange" :page-size="pagesize" :total="total" style="float:right;"></el-pagination>
		</el-col>

		<!--编辑界面-->
		<el-dialog :title="editformtitle" :visible.sync="editFormVisible" :close-on-click-modal="false">
			<el-form :model="editForm" label-width="100px" :rules="formRules" ref="editForm">
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>
	</section>
</template>
<script>
	import util from '../../common/js/util'
	import { getListPage, delData, saveData } from '../../api/api';
	export default {
		data() {
			return {
				filters:{
					entimes:'',entimee:'',service_code:''
				},
				datalist: [],
				total: 0,
				pagesize:20,
				page: 1,
				listLoading: false,
				/////////////Form 表单
				editformtitle:'',//form编辑名称
				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				formRules: {
				},
				//编辑界面数据
				editForm: {
					actionurl:'',sqlid:'',entime:'',service_code:'',cpcode:'',spcode:'',service_name:'',mobile:''
				}
			}
		},
		methods: {
			getLists:function(){
				let para = {
					page: this.page,
					pagesize:this.pagesize,
					actionurl:'default/getList',
					entimes:this.filters.entimes,
					entimee:this.filters.entimee,
					sqlid:'sp_reqData.reports_query',
					service_code:this.filters.service_code
				};
				this.listLoading = true;
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.total = res.data.total;
						this.datalist = res.data.datas;
					}
					this.listLoading = false;
				});
			},
			handleAdd:function(){
				this.editFormVisible = true;
				this.editformtitle = '新增';
				this.editForm = {
					actionurl:'default/save',sqlid:'sp_reqData.add',entime:'',service_code:'',cpcode:'',spcode:'',service_name:'',mobile:''
				};
			},
			handleEdit: function (index, row) {
				this.editFormVisible = true;
				this.editformtitle = '编辑';
				this.editForm = Object.assign({}, row);
				this.editForm.actionurl = 'default/save';//设置Sqlid
				this.editForm.sqlid = 'sp_reqData.upt';
			},
			editSubmit:function(){
				let para = Object.assign({}, this.editForm);
				util.saveFunction(this,para);
			}
		},
		mounted() {
			this.filters.entimes = util.formatDate.getdatestr(0, 'yyyy-MM-dd');
			this.filters.entimee = util.formatDate.getdatestr(0, 'yyyy-MM-dd');
			this.getLists();
		}
	}	
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// spreport.vue?7ca3964e